/* eslint-disable no-console */
import {LeftOutlined, RightOutlined} from '@ant-design/icons';
import {Carousel, CarouselProps} from 'antd';
import React, {useState} from 'react';

import {ICarouselData} from './interface/ICarousel';

const CarouselComp: React.FC<
  CarouselProps & {
    data: ICarouselData[];
    showArrows?: boolean;
    type?: 'banner' | 'graph';
  }
> = ({data, showArrows = true, type = 'banner', ...props}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleAfterChange = (current: number) => {
    setCurrentIndex(current);
  };

  const RightArrow = () => {
    return (
      <div>
        <RightOutlined style={{color: '#677489', fontSize: '24px'}} />
      </div>
    );
  };

  const LeftArrow = () => {
    return (
      <div>
        <LeftOutlined style={{color: '#677489', fontSize: '24px'}} />;
      </div>
    );
  };

  return (
    <Carousel
      {...props}
      pauseOnDotsHover
      pauseOnHover
      arrows={showArrows}
      nextArrow={
        showArrows && currentIndex < data.length - 1 ? RightArrow() : undefined
      }
      prevArrow={showArrows && currentIndex > 0 ? LeftArrow() : undefined}
      className={type}
      afterChange={handleAfterChange}
      dots={false}
    >
      {data.map((item, index) => {
        return (
          <div key={index} style={{height: '100%'}}>
            {item.content}
          </div>
        );
      })}
    </Carousel>
  );
};

export default CarouselComp;
